import { Component } from '@angular/core';

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss']
})
export class RoadmapComponent {
  items = [
    {
      title: "roadmap_title_1",
      subtitle: "roadmap_subtitle_1",
      description: "roadmap_desc_1",
    },
    {
      title: "roadmap_title_2",
      subtitle: "roadmap_subtitle_2",
      description: "roadmap_desc_2",
    },
    {
      title: "roadmap_title_3",
      subtitle: "roadmap_subtitle_3",
      description: "roadmap_desc_3",
    },
    {
      title: "roadmap_title_4",
      subtitle: "roadmap_subtitle_4",
      description: "roadmap_desc_4",
    },

  ]
}
